// extracted by mini-css-extract-plugin
export default {"children":"GroupedWorkItem_children__6G1Rs","list":"GroupedWorkItem_list__AtIfK","list__group-item":"GroupedWorkItem_list__group-item__D6XNn"};